import React, { createContext, useContext } from 'react';

import type { PaymentFormValidationRules } from './validation';

const PaymentFormValidationContext = createContext<PaymentFormValidationRules | null>(null);

export function PaymentFormValidationProvider({
  value,
  children,
}: {
  value: PaymentFormValidationRules;
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <PaymentFormValidationContext.Provider value={value}>
      {children}
    </PaymentFormValidationContext.Provider>
  );
}

export function usePaymentFormValidationRules(): PaymentFormValidationRules {
  const ctx = useContext(PaymentFormValidationContext);
  if (!ctx) {
    throw new Error(
      'usePaymentFormValidationRules must be used within PaymentFormValidationProvider',
    );
  }
  return ctx;
}
